export default __webpack_public_path__ + "static/media/picLinhTran.64eeaf11.png";